var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_button),expression:"show_button"}],staticClass:"d-md-none m-b-15",attrs:{"to":{name: 'Categories'},"block":"","variant":"success"}},[_vm._v(" Ver categorias ")])}
var staticRenderFns = []

export { render, staticRenderFns }